export default class LibLoader {
  static loadedLibs = [];
  static inProgressLoads = [];
  static waitlist = {};

  static load = (source, onLoad, onError) => {
    if (this.waitlist[source])
      this.waitlist[source].push({ onLoad, onError });
    else
      this.waitlist[source] = [{ onLoad, onError }];

    if (this.inProgressLoads.includes(source) || this.loadedLibs.includes(source)) {
      return console.log(`[LibLoader] ${source} already loading. onLoad callback saved to waitlist`);
    }

    this.inProgressLoads.push(source);

    console.log(`[LibLoader] load ${source}...`);

    const script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log(`[LibLoader] ${source} successfully loaded`);
      this.inProgressLoads.filter(s => s !== source);
      this.loadedLibs.push(source);

      this.waitlist[source]?.forEach(callbacks => { console.log('[LibLoader] onLoad call', callbacks.onLoad); callbacks.onLoad(); });
    }

    script.onerror = (e) => {
      console.log(`[LibLoader] error during load ${source}`);
      this.inProgressLoads.filter(s => s !== source);

      this.waitlist[source]?.forEach(callbacks => { console.log('[LibLoader] onError call', callbacks.onError); callbacks.onError(e); });
    }

    document.body.appendChild(script);
  }

  static clearWaitlist = () => {
    this.waitlist = {};
  }
}
